export default __webpack_public_path__ + "static/media/zertiassist_iconos_upload_24px.90a0b2b2.svg";